import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'accrual-cep';
export const ENTITY_PLURAL = 'Accrual Cep';

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Foglio',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'foglio',
  },
  {
    elementLabel: 'Prospetto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'prospetto.nomeBreve',
  },
  {
    elementLabel: 'Codice',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'codice',
  },
  {
    elementLabel: 'Lettera/Numero',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'letteraNumero',
  },
  {
    elementLabel: 'Descrizione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizione',
  },
  {
    elementLabel: 'Importo',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'importo',
    sortable: false,
    minWidth: 160,
    maxWidth: 220,
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'Calcolata',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'calcolata',
    minWidth: 80,
    maxWidth: 80,
  },
  {
    elementLabel: 'Ordinamento',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'ordinamento',
    minWidth: 80,
    maxWidth: 80,
  },
];
